module.exports = __webpack_public_path__ + "img/official-logo.8871f038.png";